import PermissionButton from '../../permissions/PermissionButton';
import React from 'react';
import { Button, Popconfirm, message } from 'antd';
import { useDeleteEntrepot } from '../../hooks/entrepotHooks';
import { useNavigate } from 'react-router-dom';

const EntrepotDeleteButton = ({ code_ent, onSuccess }) => {
  const { remove, loading } = useDeleteEntrepot();
  const navigate = useNavigate();

  const handleDelete = async () => {
    try {
      await remove(code_ent);
      message.success('Entrepôt supprimé avec succès');
      if (onSuccess) {
        onSuccess();
      } else {
        navigate('/entrepot');
      }
    } catch (error) {
      message.error(error.response?.data?.message || error.message || 'Erreur lors de la suppression');
    }
  };

  if (code_ent === '2') {
    return (
      <div>
        <p style={{ color: 'red', fontWeight: 'bold' }}>
          L'entrepôt avec le code "2" ne peut pas être supprimé car il est protégé.
        </p>
        <Button onClick={() => navigate('/entrepot')}>
          Retour à la liste
        </Button>
      </div>
    );
  }

  return (
    <div>
      <Popconfirm
        title="Êtes-vous sûr de vouloir supprimer cet entrepôt?"
        description="Cette action est irréversible."
        onConfirm={handleDelete}
        okText="Oui"
        cancelText="Non"
      >
        <PermissionButton permissionModule="warehouses" permissionAction="delete" danger loading={loading} style={{ marginRight: 8 }}>
          Confirmer la suppression
        </PermissionButton>
      </Popconfirm>
      <Button onClick={() => navigate('/entrepot')}>
        Annuler
      </Button>
    </div>
  );
};

export default EntrepotDeleteButton;

